module.exports = __webpack_public_path__ + "assets/img/768_aboutus_img__colorsystem_1.5f6515a8.svg";